const fonts = `Unica77, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;

const fontFamilies = {
    body: fonts,
    heading: fonts,
};

export default fontFamilies;
